import { render, staticRenderFns } from "./WishlistButton.vue?vue&type=template&id=8ab8fd2a&scoped=true&"
import script from "./WishlistButton.vue?vue&type=script&lang=ts&"
export * from "./WishlistButton.vue?vue&type=script&lang=ts&"
import style0 from "./WishlistButton.vue?vue&type=style&index=0&id=8ab8fd2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab8fd2a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsHeartIcon24px: require('/var/www/packages/theme/components/icons/heart/HeartIcon24px.vue').default,AtomsCounter: require('/var/www/packages/theme/components/atoms/Counter.vue').default,AtomsKEButton: require('/var/www/packages/theme/components/atoms/KEButton.vue').default})
